import { render, staticRenderFns } from "./region.select.vue?vue&type=template&id=58f58814&scoped=true&"
import script from "./region.select.vue?vue&type=script&lang=js&"
export * from "./region.select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f58814",
  null
  
)

export default component.exports